"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "type", "children", "items", "checks"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".List {\n  margin: 1rem 0;\n  padding-left: 2rem;\n}\n.List:not(ol, .List__checks) {\n  list-style: disc;\n}\n.List > .List__sub_list {\n  list-style: circle;\n}\n.List > .List__sub_list > .List__sub_list {\n  list-style: none;\n}\n.List > .List__sub_list > .List__sub_list > li::before {\n  content: \"-\";\n  padding-right: 0.5rem;\n}\n.List .List__sub_list {\n  margin-left: 1.5rem;\n}\n.List__checks li::before {\n  content: \"\";\n  display: inline-block;\n  height: 1.5rem;\n  width: 1.5rem;\n  background-size: cover;\n  background-image: var(--checks);\n  background-repeat: no-repeat;\n  margin-right: 10px;\n  vertical-align: middle;\n}\n.List li {\n  color: #424242;\n  margin-bottom: 0.5rem;\n  line-height: 1.5rem;\n  font-size: 1rem;\n}\n.List__checks li {\n  list-style: none;\n}\n.List__checks > .List__sub_list {\n  list-style: disc;\n}";
  var fileName = "List_List";
  var element = document.querySelector("style[data-sass-component='List_List']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var List = function List(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'ul' : _ref$type,
    children = _ref.children,
    items = _ref.items,
    checks = _ref.checks,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var Type = type;
  var createList = function createList(obj, accumulator, keyIndex) {
    if (typeof obj === 'string' || typeof obj === 'number' || 'props' in obj) {
      accumulator.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(Item, {
        children: obj
      }, ++keyIndex));
      return accumulator;
    }
    if (Array.isArray(obj)) {
      obj.forEach(function (k) {
        return createList(k, accumulator, ++keyIndex);
      });
      return accumulator;
    }
    if ((0, _typeof2["default"])(obj) === 'object' && obj !== null && !Array.isArray(obj)) {
      var nest = [];
      var ac = accumulator;
      Object.keys(obj).forEach(function (k) {
        ac.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(Item, {
          children: k
        }, ++keyIndex));
        createList(obj[k], nest, ++keyIndex);
      });
      ac.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(Type, {
        className: "List__sub_list",
        children: nest
      }, keyIndex + Math.random()));
      return ac;
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Type, _objectSpread(_objectSpread({
    role: "list",
    className: "List ".concat(className, " ").concat(checks ? 'List__checks' : '')
  }, rest), {}, {
    children: createList(items, [], 0)
  }));
};
var Item = function Item(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
    role: "listitem",
    children: children
  });
};
var _default = List;
exports["default"] = _default;